import Vue from "vue";
import Vuetify from "vuetify/lib";
import { svgIconNames } from "@/assets";
import SVGIcon from "@/components/SVGIcon";
import pdsVars from "@/pds/styles/pds-js-variables.scss";
import "@fortawesome/fontawesome-free/css/all.css";

Vue.use(Vuetify);

const customAlertIcons = {
  info: "fa-circle-info",
  warning: "fa-triangle-exclamation",
  error: "fa-circle-exclamation",
  success: "fa-circle-check"
};

const vuetify = new Vuetify({
  theme: {
    themes: {
      light: {
        primary: pdsVars.colorPtRoyal,
        secondary: pdsVars.colorUiGrey30,
        accent: "#82B1FF",
        error: pdsVars.colorAlertRed,
        info: "#2196F3",
        success: pdsVars.colorAlertGreen,
        warning: "#FFC107",
        //Move these to PDS
        colorNeutralsNavy50: "#EEEFF2",
        colorNeutralsNavy100: "#D0D4DA",
        colorNeutralsNavy150: "#B6BBC6",
        colorNeutralsNavy200: "#A0A9B5",
        colorNeutralsNavy300: "#68788D",
        colorNeutralsNavy400: "#3D4A61",
        colorNeutralsNavy500: "#122846",
        colorNeutralsNavy600: "#0E2038",
        colorNeutralsNavy700: "#0B182A",
        colorNeutralsNavy800: "#07101C",
        colorNeutralsNavy900: "#04080E",
        colorPtRoyal50: "#F0F4FA",
        colorPtRoyal100: "#CEDAEC",
        colorPtRoyal200: "#9DB4D9",
        colorPtRoyal300: "#6C8FC5",
        colorPtRoyal400: "#3B69B2",
        colorPtRoyal500: "#0A449F",
        colorPtRoyal600: "#08367F",
        colorPtRoyal700: "#06295F",
        colorPtRoyal800: "#041B40",
        colorPtRoyal900: "#020E20",
        colorPtBlue50: "#F3F9FE",
        colorPtBlue100: "#D6EBFF",
        colorPtBlue200: "#ADD6FF",
        colorPtBlue300: "#85C2FF",
        colorPtBlue400: "#5CADFF",
        colorPtBlue500: "#3399FF",
        colorPtBlue600: "#297ACC",
        colorPtBlue700: "#1F5C99",
        colorPtBlue800: "#143D66",
        colorPtBlue900: "#0A1F33",
        colorSemanticStateGreen50: "#F2FCF8",
        colorSemanticStateGreen100: "#DEF7EB",
        colorSemanticStateGreen200: "#C9F3DE",
        colorSemanticStateGreen300: "#9FEAC4",
        colorSemanticStateGreen400: "#4DDB96",
        colorSemanticStateGreen500: "#29CC7D",
        colorSemanticStateGreen600: "#21A666",
        colorSemanticStateGreen700: "#15663E",
        colorSemanticStateGreen800: "#0A331F",
        colorSemanticStateGreen900: "#051A10",
        colorSemanticStateYellow50: "#FFFAF0",
        colorSemanticStateYellow100: "#FFF1D6",
        colorSemanticStateYellow200: "#FFE8BD",
        colorSemanticStateYellow300: "#FFD68A",
        colorSemanticStateYellow400: "#FFCB66",
        colorSemanticStateYellow500: "#FFBA33",
        colorSemanticStateYellow600: "#CC9529",
        colorSemanticStateYellow700: "#99701F",
        colorSemanticStateYellow800: "#664A14",
        colorSemanticStateYellow900: "#33250A",
        colorSemanticStateRed50: "#FFF0F0",
        colorSemanticStateRed100: "#FFD6D6",
        colorSemanticStateRed200: "#FFBDBD",
        colorSemanticStateRed300: "#FF8A8A",
        colorSemanticStateRed400: "#FF6666",
        colorSemanticStateRed500: "#FF3333",
        colorSemanticStateRed600: "#CC2929",
        colorSemanticStateRed700: "#991F1F",
        colorSemanticStateRed800: "#661414",
        colorSemanticStateRed900: "#330A0A",
        colorVpGreen50: "#F3FDF3",
        colorVpGreen100: "#D6F5D6",
        colorVpGreen150: "#C0F4C0",
        colorVpGreen200: "#ADEBAD",
        colorVpGreen300: "#85E085",
        colorVpGreen400: "#5CD65C",
        colorVpGreen500: "#33CC33",
        colorVpGreen600: "#29A329",
        colorVpGreen700: "#1F7A1F",
        colorVpGreen800: "#145214",
        colorVpGreen900: "#0A290A",
        //Custom variables from ProviderTrust Design System
        ...pdsVars,
        text: {
          primary: "#3D4A61"
        }
      }
    }
  },
  icons: {
    values: {
      ...svgIconNames.reduce((prev, cur) => {
        prev[cur] = {
          component: SVGIcon,
          props: {
            name: cur
          }
        };
        return prev;
      }, {}),
      ...customAlertIcons
    }
  },
  breakpoint: {
    thresholds: {
      xl: 1264
    }
  }
});

export default vuetify;
